import { NamedProperty } from "sprint-common-web";

import { IntegratorLookupResponse } from "../../admin/integrator/api/GetIntegratorsLookupResponse";

export type Integrator = NamedProperty;

export const mapToIntegrator = (response: IntegratorLookupResponse): Integrator => ({
    id: response.id,
    name: response.name
});
